import { render, staticRenderFns } from "./TextAreaInputField.vue?vue&type=template&id=49e81a05"
import script from "./TextAreaInputField.vue?vue&type=script&lang=js"
export * from "./TextAreaInputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports